module.exports = __webpack_public_path__ + "img/Landing.0d27e592.png";